import logo from '@/routes/gateway/assets/united-square-logo.png'
import { useI18n } from '@runtime/core/i18n/i18n'
import type { Ref } from 'react'
import styles from './PlayHeader.module.scss'
import PlayHeaderActions from './PlayHeaderActions'
import PlayNavigationLink from './PlayNavigationLink'
import PlayPieceMark from './PlayPieceMark'
import PlayMenuIcon from './PlayMenuIcon'

export default function PlayHeader({
  onOpenMenu,
  menuOpen,
  menuButtonRef,
}: {
  onOpenMenu: () => void
  menuOpen: boolean
  menuButtonRef: Ref<HTMLButtonElement>
}) {
  const { t } = useI18n()
  return (
    <header className={styles.header} data-testid="play-header">
      <button
        ref={menuButtonRef}
        type="button"
        className={styles.menuButton}
        onClick={onOpenMenu}
        aria-label={t('common.playNavigation.openMenu')}
        aria-expanded={menuOpen}
        aria-controls="play-mobile-menu"
        data-testid="play-menu-open"
      >
        <PlayMenuIcon />
      </button>
      <PlayNavigationLink
        to="/home"
        className={styles.brand}
        aria-label={t('common.playNavigation.goHome')}
        data-testid="play-brand"
      >
        <PlayPieceMark className={styles.brandMark} />
        <img src={logo} alt="" />
      </PlayNavigationLink>
      <PlayHeaderActions />
    </header>
  )
}
